import React from 'react';
import CommonModal from './CommonModal';

const GuardedNavigationModal = ({ isOpen, onCancel, onConfirm }) => {
  return (
    <CommonModal isOpen={isOpen} onClose={onCancel} elId="leaveModal">
      <div className="modal-header">
        <h5 className="modal-title">Leave this page?</h5>
        <button type="button" className="btn-close" onClick={onCancel}></button>
      </div>
      <div className="modal-body">
        You are in the middle of an order. Are you sure you'd like to cancel this order?
      </div>
      <div className="modal-footer">
        <button className="btn btn-secondary" onClick={onCancel}>Cancel</button>
        <button className="btn btn-danger" onClick={onConfirm}>Yes, leave</button>
      </div>
    </CommonModal>
  );
};

export default GuardedNavigationModal;
